import React from "react";
import PatientLoader from "../../../common/PatientLoader";
import RiskPill from "../../../common/RiskPill";
import { getFullName, getInitials } from "../../../../util/helpers";

const PatientIntro = ({ singlePatientData, loading, downloadMode }) => {
  const initialDP = `https://placehold.co/125x125/f1f1f5/395E9D/?text=${getInitials(
    getFullName(singlePatientData)
  )}`;
  let profilePicture = downloadMode
    ? initialDP
    : singlePatientData?.profile_picture || initialDP;
  return (
    <>
      {loading ? (
        <PatientLoader />
      ) : (
        <div className="container-fluid w-100 d-flex mt-2">
          <div>
            <img
              height="125px"
              width="125px"
              alt="User's DP"
              style={{ borderRadius: "100%", padding: "0.2rem" }}
              src={profilePicture}
            />
            <RiskPill type={singlePatientData.flag} />
          </div>
          <div className="container-fluid">
            <div className="d-flex my-4" style={{ gap: "15px" }}>
              <div>
                <small
                  style={{
                    display: "block",
                    fontSize: "0.7rem",
                    fontWeight: "400",
                    letterSpacing: "2px",
                  }}
                >
                  FIRST NAME
                </small>
                <h2
                  className="primary-text"
                  style={{ textTransform: "capitalize" }}
                >
                  {singlePatientData?.first_name}
                </h2>
              </div>
              <div>
                <small
                  style={{
                    display: "block",
                    fontSize: "0.7rem",
                    fontWeight: "400",
                    letterSpacing: "2px",
                  }}
                >
                  LAST NAME
                </small>
                <h2
                  className="primary-text"
                  style={{ textTransform: "capitalize" }}
                >
                  {singlePatientData?.last_name}
                </h2>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PatientIntro;
